import Axios from "axios";

import { configFile } from "../configFile";

// Egy nyereményjáték (kampány) a szerverről. A megjelenő szövegek MIND innen
// jönnek — a web semmilyen kampányszöveget nem éget be, így a CMS-ben
// létrehozott új játék deploy nélkül elindul.
export type ICompetition = {
  id: number;
  key: string;
  name: string;
  title: string;
  acceptText: string;
  declineText: string;
  linkText: string;
  rulesUrl: string;
  headerImagePath: string;
  logoImagePath: string;
};

export type ICompetitionConsentStatus = {
  active: boolean;
  competition: ICompetition | null;
  decided: boolean;
  accepted: boolean | null;
};

export const shouldAskConsent = (
  status: ICompetitionConsentStatus | null
): boolean => !!status && status.active && !status.decided;

export const hasRulesLink = (competition: ICompetition): boolean =>
  !!competition.linkText && !!competition.rulesUrl;

// A képútvonalat ugyanúgy állítjuk össze, mint a többi szerveroldali kép esetén
// (lásd PayDeskPopup): <serverBaseUrl>/files/<filePath>.
const fileUrl = (path: string): string =>
  path ? `${configFile.serverBaseUrl}/files/${path}` : "";

export const headerImageUrl = (competition: ICompetition): string =>
  fileUrl(competition.headerImagePath);

// Üres = nincs saját kampány-logó, a beépített Pizza Sprint logó jelenik meg.
export const logoImageUrl = (competition: ICompetition): string =>
  fileUrl(competition.logoImagePath);

/// Fail-open: hálózati hiba esetén `null` — ilyenkor nem kérdezünk, és a
/// megrendelést sem blokkoljuk.
export async function getCompetitionConsent(): Promise<ICompetitionConsentStatus | null> {
  try {
    const res = await Axios.get("/competition_consent");
    return res.data as ICompetitionConsentStatus;
  } catch (e) {
    return null;
  }
}

/// A döntés mentése az épp futó játékra (a szerver dönti el, melyik az).
/// `change` a felső menüből indított tudatos módosításnál — e nélkül a szerver
/// nem írja felül a korábbi választ.
export async function submitCompetitionConsent(
  accepted: boolean,
  change = false
): Promise<boolean> {
  try {
    await Axios.post(
      "/competition_consent",
      { accepted },
      { params: change ? { change: "1" } : undefined }
    );
    return true;
  } catch (e) {
    return false;
  }
}
